var _excluded = ["value", "mask", "onChange", "onBlur", "onKeyPressed", "readOnly", "icon", "error"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { Icon } from "../..";

/**
 * An InputMask for add Mask on input customly
 * https://github.com/sanniassin/react-input-mask
 *
 * @param {any} props
 * @returns
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var InputMaskJvs = function InputMaskJvs(props) {
  var value = props.value,
    mask = props.mask,
    onChange = props.onChange,
    onBlur = props.onBlur,
    onKeyPressed = props.onKeyPressed,
    readOnly = props.readOnly,
    icon = props.icon,
    error = props.error,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _React$useState = React.useState(value),
    valueInput = _React$useState[0],
    setValueInput = _React$useState[1];
  React.useEffect(function () {
    setValueInput(value);
  }, [value]);
  var handleInputBlur = React.useCallback(function (event) {
    var _ref = event || {},
      target = _ref.target;
    var _ref2 = target || {},
      val = _ref2.value;
    setValueInput(val);
    if (onBlur) {
      onBlur(event);
    }
  }, [onBlur]);
  var handleInput = function handleInput(event) {
    var _ref3 = event || {},
      target = _ref3.target;
    var _ref4 = target || {},
      val = _ref4.value;
    setValueInput(val);
    if (onChange) {
      onChange(event);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      position: 'relative'
    },
    children: [/*#__PURE__*/_jsx(InputMask, Object.assign({
      mask: mask,
      onChange: handleInput,
      onBlur: handleInputBlur,
      value: valueInput
    }, rest)), !readOnly && !_.isNil(icon) ? /*#__PURE__*/_jsx(Icon, {
      name: icon.name,
      onClick: icon.onClick,
      link: icon.link,
      style: {
        left: 142,
        padding: 3,
        position: 'absolute',
        top: 8
      }
    }) : '']
  });
};
InputMaskJvs.handledProps = ["error", "icon", "mask", "onBlur", "onChange", "onKeyPressed", "readOnly", "value"];
InputMaskJvs.propTypes = {
  value: PropTypes.string,
  mask: PropTypes.string,
  onChange: PropTypes.func,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.object]))]),
  onBlur: PropTypes.func,
  onKeyPressed: PropTypes.func,
  readOnly: PropTypes.bool,
  error: PropTypes.objectOf(PropTypes.string, PropTypes.number)
};
InputMaskJvs.defaultProps = {
  value: '00:00',
  mask: '',
  onChange: null,
  icon: null,
  onBlur: null,
  onKeyPressed: null,
  readOnly: false,
  error: null
};
export default InputMaskJvs;